import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../store/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../api/client/axios';
import { AxiosError } from 'axios';

export const fetchOrganization = async (query) => {
  const { data } = await apiClient.get(`/organizations/${query.queryKey[1]}`);
  return data;
};

export const useGetOrganizationHandler = (id) => {
  const dispatch = useDispatch();
  const [organization, setOrganization] = useState(undefined);

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['organization', id], // A unique key for this query
    queryFn: fetchOrganization,
    enabled: Boolean(id),
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    retry: 3,
  });

  useEffect(() => {
    if (fetchedData) {
      setOrganization(fetchedData);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        if (error.status) {
          dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
        } else {
          dispatch(showSnackbar({ message: error.message, severity: 'error' }));
        }
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);

  return {
    organization,
    isLoading,
  };
};
